import { flip, autoPlacement } from '@floating-ui/react';
/**
 * @param flipCrossAxis Allow flipping to the perpendicular side when the tooltip overflows
 *   horizontally. Turn it off when `shift()` is in play, so horizontal overflow slides the
 *   tooltip along its side instead of moving it to another one.
 */
export function getFloatingPlacement(placement, flipCrossAxis = true) {
    switch (placement) {
        case 'auto':
            return [undefined, autoPlacement()];
        case 'auto-end':
            return [
                undefined,
                autoPlacement({
                    allowedPlacements: ['top-end', 'bottom-end', 'left-end', 'right-end'],
                }),
            ];
        case 'auto-start':
            return [
                undefined,
                autoPlacement({
                    allowedPlacements: ['top-start', 'bottom-start', 'left-start', 'right-start'],
                }),
            ];
        case 'top':
        case 'bottom':
        case 'right':
        case 'left':
        case 'top-start':
        case 'top-end':
        case 'bottom-start':
        case 'bottom-end':
        case 'right-start':
        case 'right-end':
        case 'left-start':
        case 'left-end':
            return [
                placement,
                flip({
                    mainAxis: true,
                    crossAxis: flipCrossAxis,
                    fallbackAxisSideDirection: 'start',
                }),
            ];
        default:
            // @ts-expect-error - when all cases covered
            return null;
    }
}
